import React from "react";
import PrintField from "../../shared/PrintField";
import "./Dissolution.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

const Dissolution = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      <div className="inv-paper inv-dissolution" ref={ref}>
        {/* ===== Title ===== */}
        <div className="dis-title inv-bold">ประกาศเลิกห้างหุ้นส่วนจำกัด</div>

        {/* ===== Center company / reg ===== */}
        <div className="dis-center">
          <div className="dis-center-row">
            <span className="inv-bold">ห้างหุ้นส่วนจำกัด</span>
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "280px" }}
              spellCheck={false}
            />
          </div>

          <div className="dis-center-row">
            <span className="inv-bold">ทะเบียนเลขที่</span>
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "280px" }}
              spellCheck={false}
            />
          </div>
        </div>

        {/* ===== Body ===== */}
        <div className="inv-body dis-body">
          <p className="inv-paragraph dis-paragraph">
            ขอประกาศให้ทราบโดยทั่วกันว่า ที่ประชุมผู้เป็นหุ้นส่วน ของห้างหุ้นส่วนจำกัด
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "210px" }}
              spellCheck={false}
            />
            ได้ตกลงให้เลิกห้างหุ้นส่วนนี้ ตั้งแต่วันที่
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "48px" }}
              spellCheck={false}
            />
            เดือน
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "110px" }}
              spellCheck={false}
            />
            ปี
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "90px" }}
              spellCheck={false}
            />
            เป็นต้นไป
          </p>

          <p className="inv-paragraph dis-paragraph">
            จึงขอประกาศให้ทราบโดยทั่วกัน และหนี้ทั้งหลายของห้างหุ้นส่วนฯ นี้
            ให้ไปติดต่อสอบถามหรือยื่นคำขอชำระหนี้ได้ที่ ณ สำนักงานของผู้ชำระบัญชี
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "255px" }}
              spellCheck={false}
            />
            ภายในกำหนด
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "70px" }}
              spellCheck={false}
            />
            วัน นับตั้งแต่วันประกาศเป็นต้นไป
          </p>

          {/* ===== Announce date (right) ===== */}
          <div className="dis-right dis-announce">
            <span className="inv-bold">ประกาศ ณ วันที่</span>
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "55px" }}
              spellCheck={false}
            />
            
          </div>

          {/* ===== Signature (right, stacked) ===== */}
          <div className="dis-right dis-sign">
            <div className="dis-sign-name">( <InputField className="inv-sign-name-field" printFit optional={false} /> )</div>
            <div className="dis-sign-role inv-bold">ผู้ชำระบัญชี</div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Dissolution;
